export default {
  computed: {
    computedAuthProfile() {
      return this.$store.state.auth.profile[
        "https://gis.wbsnowmaking.com/app_metadata"
      ].roles[0];
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuthDept() {
      if (
        this.$store.state.auth.profile[
          "https://gis.wbsnowmaking.com/app_metadata"
        ].department
      ) {
        return this.$store.state.auth.profile[
          "https://gis.wbsnowmaking.com/app_metadata"
        ].department[0];
      } else {
        return null;
      }
    }
  }
};
